export function isEven(value) {
    return value % 2 === 0;
}
export function isOdd(value) {
    return value % 2 === 1;
}
export function sum(values) {
    return values.reduce((partialSum, a) => partialSum + a, 0);
}
/**
 * Convert a number to string and count digits after the decimal dot.
 */
function countDecimals(value) {
    if (isNaN(value))
        return 0;
    if (Math.floor(value) === value)
        return 0;
    return value.toString().split(".")[1].length || 0;
}
//# sourceMappingURL=numbers.js.map